// File: src/components/car/CarSpecifications.jsx
import React, { useState } from 'react';
import './CarSpecifications.css';
import CarSpecificationsModal from './CarSpecificationsModal';


  const CarSpecifications = ({ car, onBookNow, onTestDrive }) => {
  const [showModal, setShowModal] = useState(false);
  
  console.log('🔧 CarSpecifications received car:', car);
  console.log('📋 car_specification data:', car?.car_specification);
  
  const specs = car?.car_specification || {};

  const handleViewAll = () => {
    setShowModal(true);
  };

  return (
    <>
      <div className="car-specifications-section">
        <h3 className="section-title">Car Specifications</h3>
        
        <div className="specs-highlights">
          <Spec 
            icon="⛽" 
            label="Mileage (ARAI)" 
            value={specs.mileage ? `${specs.mileage} kmpl` : 'N/A'} 
          />
          <Spec 
            icon="📏" 
            label="Ground clearance" 
            value={specs.ground_clearance ? `${specs.ground_clearance} mm` : 'N/A'} 
          />
          <Spec 
            icon="🎒" 
            label="Boot space" 
            value={specs.boot_space ? `${specs.boot_space} litres` : 'N/A'} 
          />
          <Spec 
            icon="🔧" 
            label="Displacement" 
            value={specs.engine_displacement ? `${specs.engine_displacement} cc` : 'N/A'} 
          />
        </div>

        <button 
          className="view-all-specs-btn"
          onClick={handleViewAll}
        >
          VIEW ALL SPECIFICATIONS
        </button>
      </div>

      <CarSpecificationsModal 
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        car={car}
        onBookNow={onBookNow}
        onTestDrive={onTestDrive}
      />
    </>
  );
};

const Spec = ({ icon, label, value }) => (
  <div className="spec-highlight">
    <span className="spec-icon">{icon}</span>
    <div className="spec-detail">
      <span className="spec-label">{label}</span>
      <strong className="spec-value">{value}</strong>
    </div>
  </div>
);

export default CarSpecifications;